module.exports = __webpack_public_path__ + "static/fonts/Linearicons-Free.6506072.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Linearicons-Free.woff?w118d
// module id = j9tn
// module chunks = 1